import React from "react";
import { Table, Button, Tooltip } from "antd";
import { SettingOutlined } from "@ant-design/icons";

export default function PumpTable({ data, onEdit }) {
  const columns = [
    {
      title: "Pump Title",
      dataIndex: "title",
      key: "title",
      align: "center",
    },
    {
      title: "Pump Make",
      dataIndex: "pump_maker",
      key: "pump_maker",
      align: "center",
    },
    {
      title: "Pump Model",
      dataIndex: "pump_model",
      key: "pump_model",
      align: "center",
    },

    {
      title: "Action",
      key: "action",
      align: "center",
      render: (_, record) => (
        <Tooltip title="Configure parameters">
          <Button
            type="primary"
            size="small"
            onClick={() => onEdit?.(record)}
            style={{ marginRight: "5px" }}
            icon={<SettingOutlined />}
          />
        </Tooltip>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      columns={columns}
      bordered
      pagination={{ pageSize: 10 }}
      rowKey="key"
      className="custom-table"
    />
  );
}
